import ChevronRight from "lucide-react/dist/esm/icons/chevron-right";
import { memo } from "react";

import { IgButton } from "@intelligems/ig-theme";
import Box from "@mui/material/Box";

const EXPAND_BUTTON_SX = {
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: "transparent" },
  gap: 1,
} as const;

interface ExpandChevronProps {
  count: number;
  expanded: boolean;
  onToggle: () => void;
}

export const ExpandChevron = memo(function ExpandChevron({
  count,
  expanded,
  onToggle,
}: ExpandChevronProps) {
  return (
    <IgButton
      variant="contained"
      onClick={onToggle}
      size="extraSmall"
      sx={EXPAND_BUTTON_SX}
    >
      <Box component="span" sx={{ display: { xs: "none", md: "inline" } }}>
        {count} more notification{count > 1 ? "s" : ""}
      </Box>
      <Box
        sx={{
          transition: "transform 0.2s",
          transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
        }}
      >
        <ChevronRight color="white" size={20} />
      </Box>
    </IgButton>
  );
});
